/**
 * LifecycleStatusBadge — D-032 §6 status display chip.
 * Color-coded by lifecycle stage.
 */

import React from "react";
import { Chip } from "@mui/material";
import { LIFECYCLE_LABELS, PRODUCTION_VISIBLE } from "../../utils/documentLifecycleApi";

const STATUS_COLOR = {
  RECEIVED:                 { bg: "#e9ecef", color: "#495057" },
  IN_REVIEW:                { bg: "#fff3cd", color: "#664d03" },
  CHECKED:                  { bg: "#cfe2ff", color: "#052c65" },
  SUBMITTED_FOR_APPROVAL:   { bg: "#cfe2ff", color: "#052c65" },
  APPROVED:                 { bg: "#d1e7dd", color: "#0a3622" },
  APPROVED_AS_NOTED:        { bg: "#d1e7dd", color: "#0a3622" },
  CURRENT_FOR_FABRICATION:  { bg: "#198754", color: "#ffffff" },
  CURRENT_FOR_ERECTION:     { bg: "#198754", color: "#ffffff" },
  CURRENT_WITH_CORRECTIONS: { bg: "#fd7e14", color: "#ffffff" },
  RETURNED_FOR_REVISION:    { bg: "#fff3cd", color: "#664d03" },
  REJECTED_HOLD:            { bg: "#f8d7da", color: "#58151c" },
  SUPERSEDED:               { bg: "#e9ecef", color: "#6c757d" },
  OBSOLETE:                 { bg: "#6c757d", color: "#ffffff" },
  ARCHIVED_RECORD:          { bg: "#212529", color: "#ffffff" },
};

export default function LifecycleStatusBadge({ status, size = "small" }) {
  const colors = STATUS_COLOR[status] || { bg: "#e9ecef", color: "#495057" };
  const label = LIFECYCLE_LABELS[status] || status;
  const isProduction = PRODUCTION_VISIBLE.includes(status);
  return (
    <Chip
      size={size}
      label={label}
      title={isProduction ? "Production-visible (Kiosk + work-orders show this)" : "Not visible to Kiosk / production"}
      sx={{ backgroundColor: colors.bg, color: colors.color, fontWeight: 600, fontSize: "0.7rem" }}
    />
  );
}
